// extracted by mini-css-extract-plugin
export default {"audio":"Audio_audio__TjQSC"};